// extracted by mini-css-extract-plugin
module.exports = {"advertiserDisclosure":"advertiser-disclosure-component_advertiserDisclosure__7wM6K"};